export default {
  elevation1: {
    boxShadow: '3px 3px 10px #00000029',
    borderRadius: 14,
  },
};
